import { Expose } from "@nts/std/serialization";
import { FindValuesOptions } from './find-values-options';

export class FindValuesExternalOptions extends FindValuesOptions {

    @Expose()
    fullRootModelName: string;

    constructor(findOptions?: FindValuesOptions) {
        super(findOptions);
        this.outputProperties = findOptions.outputProperties;
    }
}
